export default [
    {
        path: '/position-level',
        name: 'indexPositionLevel',
        meta: { title: 'indexPositionLevel' },
        component: () => import('@/pages/admin/position-level/index.vue'),
    },
    // {
    //     path: "/position-level/create",
    //     name: "createPositionLevel",
    //     meta: { title: 'createPositionLevel' },
    //     component: () => import('@/pages/admin/position-level/create.vue'),
    // },
    // {
    //     path: "/position-level/:id/edit",
    //     name: "editPositionLevel",
    //     meta: { title: 'editPositionLevel' },
    //     component: () => import('@/pages/admin/position-level/edit.vue'),
    // },
]